module.exports = __webpack_public_path__ + "img/pig.f1ac2b2d.svg";